import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { Link, useParams } from "react-router-dom";
import "./common.css";
import API_URL from "../common/Apiurl";

function Viewhomeowner() {
  const apiUrl = API_URL;
  const [items, setItems] = useState([]);
  const [averagedata, setAveragedata] = useState([]);
  const viewId = useParams();
  const homeownerId = viewId.homeownerid;

  useEffect(() => {
    const getComments = async () => {
      try {
        const postData = {
          homeowner_id: homeownerId,
        };
        const res = await fetch(`${apiUrl}/admin/viewhomeowner`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(postData),
        });
        const data = await res.json();
        if (data.status !== 200) {
          throw new Error("Data not found");
        }
        setItems(data.data);
        setAveragedata(data.average);
      } catch (error) {
        console.error("Error ", error);
      }
    };
    getComments();
  }, []);
  return (
    <div className="width90">
      <h2 className="pageTitle">View Homeowner Details</h2>
      <div className="commonCntr">
        <form className="form-horizontal" action="">
          <div className="form-group">
            <label className="control-label col-sm-2 label">Name:</label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{items.name}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Email address:
            </label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{items.email}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Address:</label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{items.address}</span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-12 label">Reviews:</label>
            <label className="control-label col-sm-2 label">
              Communication:
            </label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{averagedata.averageComm}/5</span>
              <span className="d-block">
                reviews given by {averagedata.commUsers} users.
              </span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Knowledge:</label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{averagedata.averageknowledge}/5</span>
              <span className="d-block">
                reviews given by {averagedata.knowledgeUsers} users.
              </span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Transparency:
            </label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{averagedata.averagetransparency}/5</span>
              <span className="d-block">
                reviews given by {averagedata.transparencyUsers} users.
              </span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">Cleanliness:</label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{averagedata.averagecleanliness}/5</span>
              <span className="d-block">
                reviews given by {averagedata.cleanlinessUsers} users.
              </span>
            {/* </div> */}
          </div>
          <div className="form-group mt-4">
            <label className="control-label col-sm-2 label">
              Professionalism:
            </label>
            {/* <div className="col-sm-4 mt-1"> */}
              <span>{averagedata.averageprofessionalism}/5</span>
              <span className="d-block">
                reviews given by {averagedata.professionalismUsers} users.
              </span>
            {/* </div> */}
          </div>
          {items?.documents?.map((e) => {
              return (
                <div className="form-group mt-4">
                  <label className="control-label col-sm-3 label">
                    Document Approval Status
                  </label>
                  <input
                    type="checkbox"
                    id="driving_licence"
                    name="driving_licence"
                    checked={e.status}
                  />{" "}
                  <label className="control-label col-sm-2 label">
                    {e.type === "driving_licence" ? "Driving Licence" : "Address Documents"}
                  </label>
                  <div className="col-sm-4  mt-1">
                    <iframe
                      src={e.image}
                      // class="img-fluid small-image"
                      alt="No Document uploaded yet"
                    ></iframe>
                    <a target="_blank" href={e.image}>Preview</a>
                  </div>
                </div>
              );
            })}
          <div className="form-group mt-4">
            <div className="row">
              <div className="col">
                  <Link to={`/admin/alljobs/posted/${homeownerId}`}>Posted Jobs</Link>
              </div>
              <div className="col">
                  <Link to={`/admin/alljobs/completed/${homeownerId}`}>Completed jobs</Link>
              </div>
            </div>
          </div>
          
          <div className="col">
                  {/* <button>Completed Jobs</button> */}
                  <Link to={`/admin/alljobs/completed/${homeownerId}`}>Credits</Link>
              </div>
              <div className="col">
                  {/* <button>Completed Jobs</button> */}
                  <Link to={`/admin/wallet/transactionhistory/${homeownerId}`}>Wallets</Link>
              </div>
        </form>
      </div>
    </div>
  );
}

export default Viewhomeowner;
